export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/plus-sign-affiliates.41ef0b30.svg","height":24,"width":24};